// src/pages/ResellerInfo.jsx
// v1 — Public reseller pricing overview page (separate from private ResellerDashboard)

import React from 'react';
import Navbar from '../components/Navbar';
import BottomNav from '../components/BottomNav';

export default function ResellerInfo() {
  const slabs = [
    { range: '1–5 orders', off: '₹100 off per item' },
    { range: '6–15 orders', off: '₹125 off per item' },
    { range: '16–30 orders', off: '₹150 off per item' },
    { range: '31–50 orders', off: '₹175 off per item' },
    { range: '51+ orders', off: '₹200 off per item' },
  ];
  function contactUs() {
    const msg = "Hi! I'd like to get approved for the reseller pricing programme.";
    window.open(`https://wa.me/919363012496?text=${encodeURIComponent(msg)}`, '_blank');
  }
  return (
    <div className="app-shell">
      <Navbar showBack title="Reseller Pricing" />
      <div className="page-body" style={{ paddingBottom: 100 }}>
        <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 6, color: 'var(--navy)' }}>Reseller Pricing Programme</h1>
        <p style={{ fontSize: 13, color: '#555', lineHeight: 1.7, marginBottom: 24 }}>
          Slab-based discounts that improve as your monthly order volume grows. All orders are prepaid — your discount is applied when you place the order, no end-of-month settlements.
        </p>

        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--navy)', marginBottom: 10 }}>Monthly Discount Slabs</div>
        <table className="rsl-table">
          <thead><tr><th>Monthly Orders</th><th>Discount</th></tr></thead>
          <tbody>
            {slabs.map(s => (
              <tr key={s.range}><td>{s.range}</td><td>{s.off}</td></tr>
            ))}
          </tbody>
        </table>

        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--navy)', margin: '24px 0 10px' }}>How It Works</div>
        <ul className="rsl-list">
          <li>Each item you order counts as 1 order</li>
          <li>Discount is applied at payment, based on your running monthly count</li>
          <li>Slabs reset on the 1st of every month</li>
        </ul>

        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--navy)', margin: '24px 0 10px' }}>Important Conditions</div>
        <ul className="rsl-list">
          <li>Only prepaid orders count toward your slab</li>
          <li>COD orders and returned orders (for any reason) are deducted from your monthly count — if this drops you to a lower slab, your next order is priced at that lower rate</li>
          <li>Reseller pricing does not apply to special offers or already discounted prices, unless explicitly approved as an exception</li>
          <li>nobrand store reserves the right to change, replace, modify, or remove any of these terms at any time, without prior notice</li>
        </ul>

        <button className="btn-blue" style={{ marginTop: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }} onClick={contactUs}>
          <i className="ti ti-brand-whatsapp"></i> Get approved as a reseller
        </button>
      </div>
      <BottomNav />
      <style>{`
        .rsl-table { width: 100%; border-collapse: collapse; font-size: 12px; }
        .rsl-table th { background: var(--navy); color: #fff; padding: 8px 10px; text-align: left; font-weight: 500; }
        .rsl-table td { padding: 8px 10px; border-bottom: 0.5px solid var(--border); color: #555; }
        .rsl-table tr:nth-child(even) { background: #fafafa; }
        .rsl-list { padding-left: 18px; font-size: 12.5px; color: #555; line-height: 1.9; }
      `}</style>
    </div>
  );
}